export enum EcaModalType {
  Success = 'success',
  Error = 'error',
}

export enum ContractStateReason {
  Signed = 'Signed',
  Unsigned = 'Unsigned',
}

export type ErrorMessage = {
  operation: string;
  message: string;
};

export enum ContractOperationType {
  getContractInstance = 'getContractInstance',
}

export enum ContractOperationErrorMessage {
  getContractInstanceFailed = 'ECA getContractInstance attempt failed.',
  noContractInstanceData = 'No contract instance data available.',
}
